import $axios from "../../api";

const state = () => ({
  isLoading: false,
  isLoadingDetail: false,
  isSuccess: false,
  isSuccessDetail: false,
  errors: null,
  page: 1,
  pageDetail: 1,

  dashboardData: {},
  dashboardDataMain: {},

  listResellerByPeformance: [],
  listInactiveResellers: [],
  resellerDetails: {},
  listProductReseller: {},
  resellerProductCategoryList: {},
  resellerProductBrandList: {},
  productDetails: {},
  categoryDetails: {},
  brandDetails: {},
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LOADING_DETAIL(state, payload) {
    state.isLoadingDetail = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_SUCCESS_DETAIL(state, payload) {
    state.isSuccessDetail = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_PAGE_DETAIL(state, payload) {
    state.pageDetail = payload;
  },
  ASSIGN_DATA(state, payload) {
    state.dashboardData = payload;
  },
  ASSIGN_DATA_MAIN(state, payload) {
    state.dashboardDataMain = payload;
  },
  ASSIGN_LIST_RESELLER_BY_PEFORMANCE_DATA(state, payload) {
    state.listResellerByPeformance = payload
  },
  ASSIGN_LIST_INACTIVE_RESELLER(state, payload) {
    state.listInactiveResellers = payload
  },
  ASSIGN_RESELLER_DETAIL(state, payload) {
    state.resellerDetails = payload
  },
  ASSIGN_LIST_PRODUCT_RESELLER(state, payload) {
    state.listProductReseller = payload
  },
  ASSIGN_PRODUCT_CATEGORY_LIST(state, payload) {
    state.resellerProductCategoryList = payload
  },
  ASSIGN_PRODUCT_BRAND_LIST(state, payload) {
    state.resellerProductBrandList = payload
  },
  ASSIGN_PRODUCT_DETAIL(state, payload) {
    state.productDetails = payload
  },
  ASSIGN_CATEGORY_DETAIL(state, payload) {
    state.categoryDetails = payload
  },
  ASSIGN_BRAND_DETAIL(state, payload) {
    state.brandDetails = payload
  },
}

const actions = {
  // ini get data yang lama
  getDashboardDataMain({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios.get(`reseller/data/dashboard-stats`)
        .then((res) => {
          commit("ASSIGN_DATA_MAIN", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        });
    });
  },
  getDashboardData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios.get(`reseller/dash/1`)
        .then((res) => {
          commit("ASSIGN_DATA", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        });
    });
  },
  async getListResellerByPeformance({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const { data } = await $axios.get(`reseller/dash/2/reseller-perform`, {
        params: {
          page: state.page,
          view: rootState.Main.view,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          reseller_name: payload?.reseller_name,
          sortby: payload?.sortBy,
          sortdesc: payload?.sortdesc,
        }
      })
      commit("ASSIGN_LIST_RESELLER_BY_PEFORMANCE_DATA", data.data);
      commit("SET_SUCCESS", true)
    } catch (error) {
      commit("SET_SUCCESS", false)
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async getListInactiveReseller({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const { data } = await $axios.get(`reseller/dash/2/reseller-notperform`, {
        params: {
          page: state.page,
          view: rootState.Main.view,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          reseller_name: payload?.reseller_name,
          email: payload?.email,
          sortby: payload?.sortBy,
          sortdesc: payload?.sortdesc,
        }
      })
      commit("ASSIGN_LIST_INACTIVE_RESELLER", data.data);
      commit("SET_SUCCESS", true)
    } catch (error) {
      commit("SET_SUCCESS", false)
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async getListProductReseller({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const { data } = await $axios.get(`reseller/dash/2/product`, {
        params: {
          page: state.page,
          view: rootState.Main.view,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          product_name: payload?.product_name,
          brand_id: payload?.brand_id,
          category_id: payload?.category_id,
          sortBy: payload?.sortBy,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("ASSIGN_LIST_PRODUCT_RESELLER", data);
      commit("SET_SUCCESS", true)
    } catch (error) {
      commit("SET_SUCCESS", false)
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async getResellerProductCategoryList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const { data } = await $axios.get(`reseller/dash/2/category`, {
        params: {
          page: state.page,
          view: rootState.Main.view,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          category_name: payload?.category_name,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("ASSIGN_PRODUCT_CATEGORY_LIST", data);
      commit("SET_SUCCESS", true)
    } catch (error) {
      commit("SET_SUCCESS", false)
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async getResellerProductBrandList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const { data } = await $axios.get(`reseller/dash/2/brand`, {
        params: {
          page: state.page,
          view: rootState.Main.view,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          brand_name: payload?.brand_name,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("ASSIGN_PRODUCT_BRAND_LIST", data);
      commit("SET_SUCCESS", true)
    } catch (error) {
      commit("SET_SUCCESS", false)
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async getResellerDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const { data } = await $axios.get(`reseller/dash/3/reseller-detail`, {
        params: {
          page: state.page,
          view: rootState.Main.view,
          reseller_id: payload.reseller_id,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
          order_number: payload?.order_number,
          payment_name: payload?.payment_name,
          product_name: payload?.product_name,
        }
      })

      commit("ASSIGN_RESELLER_DETAIL", data.data);
      commit("SET_SUCCESS", true)
    } catch (error) {
      commit("SET_SUCCESS", false)
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async getProductDetails({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    try {
      const { data } = await $axios.get(`reseller/dash/3/product`, {
        params: {
          page: state.pageDetail,
          view: rootState.Main.view,
          product_id: payload.product_id,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("ASSIGN_PRODUCT_DETAIL", data);
      commit("SET_SUCCESS_DETAIL", true)
    } catch (error) {
      commit("SET_SUCCESS_DETAIL", false)
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING_DETAIL", false);
    }
  },

  async getCategoryDetails({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    try {
      const { data } = await $axios.get(`reseller/dash/3/category`, {
        params: {
          page: state.pageDetail,
          view: rootState.Main.view,
          category_id: payload.category_id,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("ASSIGN_CATEGORY_DETAIL", data);
      commit("SET_SUCCESS_DETAIL", true)
    } catch (error) {
      commit("SET_SUCCESS_DETAIL", false)
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING_DETAIL", false);
    }
  },

  async getBrandDetails({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING_DETAIL", true);
    try {
      const { data } = await $axios.get(`reseller/dash/3/brand`, {
        params: {
          page: state.pageDetail,
          view: rootState.Main.view,
          brand_id: payload.brand_id,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("ASSIGN_BRAND_DETAIL", data);
      commit("SET_SUCCESS_DETAIL", true)
    } catch (error) {
      commit("SET_SUCCESS_DETAIL", false)
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING_DETAIL", false);
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};